/* eslint-disable prettier/prettier */
import Vue from "vue";
import Vuex from "vuex";
import LocationService from "../apis/LocationService";
import User from "../apis/User";


Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    authenticated: localStorage.getItem("isAuth"),
    user: null,
    locations: [],
    notifications: [],
    spinner:false
  },
  getters: {
    authenticated(state) {
      return state.authenticated;
    },
    user(state) {
      return state.user;
    },
    locations(state) {
      return state.locations;
    },
    notifications(state) {
      return state.notifications;
    },
    spinner(state) {
      return state.spinner;
    },

    locationById: (state)  => (id) =>{
      return state.locations.filter(location => location.id === id)
    }
  },
  mutations: {
    SET_AUTHENTICATED(state, value) {
      state.authenticated = value;
      localStorage.setItem("isAuth", value)
    },
    SET_USER(state, value) {
      state.user = value;
    },
    SET_LOCATIONS(state, locations) {
      state.locations = locations;
    },
    ADD_NOTIFICATION(state, value) {
      state.notifications.push(value);
    },
    // eslint-disable-next-line no-unused-vars
    REMOVE_NOTIFICATION(state, value) {
      state.notifications = state.notifications.filter((item) => item.id!==value)
    },
    SET_SPINNER(state, value) {
      state.spinner = value;
    },
  },
  actions: {
    // eslint-disable-next-line no-unused-vars
    signIn({dispatch},form) {
      return User.login(form);
    },

    async signOut ({ dispatch }) {
      await User.logout();

      return dispatch("me");
    },

    logout ({ commit }) {

        localStorage.removeItem("isAuth");
        commit("SET_AUTHENTICATED", false);
        commit("SET_USER", null);
      
    },

    setUser({commit}, user){
      commit("SET_USER", user);
    },

    me ({ commit }) {
      User.auth()
        .then(response => {
          commit("SET_AUTHENTICATED", true);
          commit("SET_USER", response.data);
        })
        .catch(() => {
          //localStorage.removeItem("isAuth");
          commit("SET_AUTHENTICATED", false);
          commit("SET_USER", null);
      });
    },

    fetchLocations({ commit }) {
      LocationService.getLocations()
        .then(response => {
          commit("SET_LOCATIONS", response.data.data);
        })
        .catch(error => {
          console.log("error fetch locations", error.response);
        });
    },
    updateLocations({ commit }, response) {
      commit("SET_LOCATIONS", response);
      /*
      LocationService.createLocation(form)
        .then(response => {
          commit("SET_LOCATIONS", response.data.data);
        })
        .catch(error => {
          console.log("error fetch locations", error.response);
        });
        */
    },

    addNotification({commit}, notification){
      commit("ADD_NOTIFICATION", notification);
    },

    removeNotification({commit}, id){
      commit("REMOVE_NOTIFICATION", id);
    },

    updateSpinner({commit}, value){
      commit("SET_SPINNER", value);
    },

  },
  modules: {}
});
